<div class="message-container" *ngIf="message.Direction == 'UserToBot'">
	{{ message.Payload.SelectionLabel }}
</div>